/**
 * Build a Location-shaped seed for the existing LocationDialog from a pendingLocations entry
 * returned by POST /applications/parse-csv. Pending entries have shape:
 *   { id, status: 'pending', raw: { CSV cells }, partialGeocode: {...}, error: '...' }
 */
export function seedLocationFromPendingEntry(entry) {
  if (!entry) return {};
  const partial = entry.partialGeocode || {};
  const raw = entry.raw || {};
  return {
    name: partial.name || raw['Info|Name'] || '',
    address: partial.address || raw['Info|Address'] || '',
    address1: partial.address1 || raw['Info|Address'] || '',
    city: partial.city || raw['Info|City'] || '',
    regionCode: partial.regionCode || raw['Info|State'] || '',
    postcode: partial.postcode || raw['Info|Zip'] || '',
    countryCode: partial.countryCode || 'USA',
    placeId: partial.placeId || '',
    timezone: partial.timezone || '',
    lat: partial.lat || 0,
    lon: partial.lon || 0,
    aboveSeaLevel: partial.aboveSeaLevel || 0,
    visibleAddress: partial.visibleAddress || '',
    custRef: partial.custRef || '',
    coveredValue: partial.coveredValue || 0,
    details: partial.details || { num_vehicles: 0, average_car_value: 0 },
  };
}
